import { Grid } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import dayjs from 'dayjs';
import { useGlobals } from 'src/shared/contexts/appContext';
import { Event, Person } from '@mui/icons-material';
import { Colors } from 'src/shared/components/styles/colors';
import { MeRoutesEnum } from 'src/shared/models/enums/routes.enum';
import { getMyPageSetting } from 'src/shared/functions/getMyPageSetting';
import { MyPageSettingsEnum } from 'src/shared/models/enums/myPageSettings.enum';
import { useEffect, useState } from 'react';
import { GetGreetingsHeader } from '../components/atoms/greetingsHeader';
import { DashboardMeNavigateButton } from '../components/dashboardMeNavigateButton';
import { responsiveSpacing } from '../models/responsiveSpacing';

interface DashboardItem {
  title: string;
  text: string;
  key: string;
  show: boolean;
  permission?: string;
  link: MeRoutesEnum;
  Icon: JSX.Element;
}

export const DashboardMe = () => {
  const { currentMember, currentUser } = useGlobals();
  const [enableEvent, setEnableEvent] = useState<boolean>(false);

  useEffect(() => {
    if (currentMember) {
      setEnableEvent(currentMember.enableEvent);
    } else if (currentUser) {
      const hasEvent = !!getMyPageSetting(currentUser, MyPageSettingsEnum.EnableEvent, 'false');
      setEnableEvent(hasEvent);
    }
  }, [currentMember, currentUser]);

  const dashboardItems: DashboardItem[] = [
    {
      key: 'events',
      text: 'event:myPageInfo',
      title: 'event:myPage',
      link: MeRoutesEnum.MemberMyPage,
      show: true,
      Icon: <Person sx={{ width: 45, height: 45, color: Colors.MenuIcon }} />,
    },
    {
      key: 'my-profile',
      title: 'event:event',
      text: 'event:eventInfo',
      link: MeRoutesEnum.MemberEvents,
      show: enableEvent,
      Icon: <Event sx={{ width: 45, height: 45, color: Colors.MenuIcon }} />,
    },
  ];

  const visibleDashboardItems = dashboardItems.filter((x) => x.show);

  return (
    <GridWrapper>
      <Grid item xs={12}>
        <MainContentHeader
          isLoading={currentMember?.firstName === undefined}
          title={`${GetGreetingsHeader()}, ${currentMember?.firstName}`}
          subtitle={`${dayjs(new Date()).format('D MMM YYYY')}`}
        />
        <Grid container spacing={responsiveSpacing} mt={3}>
          {visibleDashboardItems.map((item) => {
            return (
              <Grid item xs={12} md={visibleDashboardItems.length > 1 ? 4 : 6} lg={visibleDashboardItems.length > 1 ? 3 : 6} key={item.key}>
                <DashboardMeNavigateButton title={item.title} text={item.text} icon={item.Icon} link={item.link} />
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </GridWrapper>
  );
};
